/* ── OFERTA YAIZA en el carrito ── 24-sep-2026 (Fabio) ──
   Reglas en snippets/yz-oferta-yaiza-carrito.liquid. Aquí:
   · el aviso: elegir modelo/color/hebilla del 3º y añadirlo (producto regalo a 0 €);
   · el vigilante, que corre tras CADA cambio del carrito (se engancha a fetch):
       - regalo con menos de 2 cinturones pagados → se quita;
       - más de 1 regalo → se deja 1;
       - regalo de cinturón + regalo de 50 € → se quita el de 50 €.
   Todo delegado en document: .drawer__inner se re-renderiza entero. Nunca MutationObserver. */
(function () {
  if (window.yzOfertaYaizaLista) return;
  window.yzOfertaYaizaLista = true;

  var ocupado = false;
  var TIPO_PAGADO = 'Cinturón';
  var TIPO_REGALO = 'Cinturón regalo';
  var TIPO_REGALO50 = 'Regalo';
  var fetchOriginal = window.fetch.bind(window);

  function post(url, datos) {
    return fetchOriginal(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' -> ' + r.status); return r.json(); });
  }

  // Mismo repintado que assets/yz-cart-extras.js (la sección cart-drawer entera).
  function repintar() {
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); return Promise.resolve(); }
    return fetchOriginal(location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        var actual = document.querySelector('.drawer__inner');
        if (actual && nuevo) actual.innerHTML = nuevo.innerHTML;
        var d = document.querySelector('cart-drawer');
        if (d) {
          if (typeof d.initializeUpsellButtons === 'function') d.initializeUpsellButtons();
          if (typeof d.initializeVariantSelectors === 'function') d.initializeVariantSelectors();
        }
        prepararAviso();
      })
      .catch(function (e) { console.error('Oferta Yaiza (repintar):', e); });
  }

  /* ---------- el aviso ---------- */
  function datosAviso(caja) {
    try { return JSON.parse(caja.querySelector('[data-yzoy-datos]').textContent); } catch (e) { return []; }
  }
  function varianteElegida(caja) {
    var lista = datosAviso(caja), m = caja.dataset.m, c = caja.dataset.c, h = caja.dataset.h;
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].m === m && lista[i].c === c && lista[i].h === h) return lista[i];
    }
    return null;
  }
  function pintarAviso(caja) {
    caja.querySelectorAll('[data-yzoy-mod]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-yzoy-mod') === caja.dataset.m); });
    caja.querySelectorAll('[data-yzoy-color]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-yzoy-color') === caja.dataset.c); });
    caja.querySelectorAll('[data-yzoy-heb]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-yzoy-heb') === caja.dataset.h); });
    var v = varianteElegida(caja), foto = caja.querySelector('[data-yzoy-foto]');
    if (foto && v && v.img) foto.src = v.img;
  }
  /* «No, gracias»: una clase en <html> + sessionStorage. Con clase (y no con hidden) el aviso no
     asoma a medias cada vez que el cajón se repinta. Se olvida al volver a añadir algo o si deja
     de haber exactamente 2 cinturones: al volver a llegar a 2, el aviso sale otra vez. */
  function decirNo() {
    try { sessionStorage.setItem('yzoy_no', '1'); } catch (e) {}
    document.documentElement.classList.add('yzoy-no');
  }
  function olvidarNo() {
    try { sessionStorage.removeItem('yzoy_no'); } catch (e) {}
    document.documentElement.classList.remove('yzoy-no');
  }

  try { if (sessionStorage.getItem('yzoy_no') === '1') document.documentElement.classList.add('yzoy-no'); } catch (e) {}

  // En /cart hay dos avisos (el del cajón y el de la página): se preparan todos.
  function prepararAviso() {
    document.querySelectorAll('[data-yzoy]').forEach(pintarAviso);
  }

  document.addEventListener('click', function (e) {
    var caja = e.target.closest && e.target.closest('[data-yzoy]');
    if (!caja) return;
    var b;
    if ((b = e.target.closest('[data-yzoy-mod]'))) { caja.dataset.m = b.getAttribute('data-yzoy-mod'); pintarAviso(caja); return; }
    if ((b = e.target.closest('[data-yzoy-color]'))) { caja.dataset.c = b.getAttribute('data-yzoy-color'); pintarAviso(caja); return; }
    if ((b = e.target.closest('[data-yzoy-heb]'))) { caja.dataset.h = b.getAttribute('data-yzoy-heb'); pintarAviso(caja); return; }
    if (e.target.closest('[data-yzoy-no]')) { decirNo(); return; }
    if ((b = e.target.closest('[data-yzoy-add]'))) {
      var v = varianteElegida(caja);
      if (!v || ocupado) return;
      ocupado = true; b.disabled = true;
      post('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] })
        .then(function () { ocupado = false; return revisar(true); })
        .catch(function (err) { console.error('Oferta Yaiza (añadir):', err); b.disabled = false; ocupado = false; });
    }
  });

  /* ---------- el vigilante ---------- */
  function revisar(forzarRepintado) {
    if (ocupado) return Promise.resolve();
    ocupado = true;
    return fetchOriginal('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pagados = 0, regalos = [], regalo50 = [];
        cart.items.forEach(function (it) {
          if (it.product_type === TIPO_PAGADO) pagados += it.quantity;
          else if (it.product_type === TIPO_REGALO) regalos.push(it);
          else if (it.product_type === TIPO_REGALO50) regalo50.push(it);
        });
        var nRegalos = regalos.reduce(function (s, it) { return s + it.quantity; }, 0);
        if (pagados !== 2) olvidarNo();
        var cambios = [];
        if (nRegalos > 0 && pagados < 2) {
          regalos.forEach(function (it) { cambios.push({ id: it.key, quantity: 0 }); });
        } else if (nRegalos > 1) {
          regalos.forEach(function (it, i) { cambios.push({ id: it.key, quantity: i === 0 ? 1 : 0 }); });
        }
        // 30-sep-2026 · Fabio: el regalo de 50 € convive con la Oferta Yaiza. Antes, con el cinturón
        // regalo en el carrito, aquí se quitaba el regalo de 50 €.
        var cadena = Promise.resolve();
        cambios.forEach(function (c) { cadena = cadena.then(function () { return post('/cart/change.js', c); }); });
        return cadena.then(function () {
          ocupado = false;
          if (cambios.length || forzarRepintado) return repintar();
          prepararAviso();
        });
      })
      .catch(function (e) { ocupado = false; console.error('Oferta Yaiza (revisar):', e); });
  }

  // Tras cualquier cambio del carrito (ficha, carrito, barra fija, carrusel…), se revisa.
  window.fetch = function (entrada) {
    var url = String((entrada && entrada.url) || entrada || '');
    // Vuelve a añadir → el «No, gracias» anterior se olvida ANTES de que el cajón se repinte.
    if (/\/cart\/add/.test(url)) olvidarNo();
    var p = fetchOriginal.apply(window, arguments);
    if (!ocupado && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(function () { revisar(false); }, 350); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { revisar(false); });
  else revisar(false);
})();
